module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_5-min.4d2b85ee.jpg";